export enum mapTypesEnum {
  GoogleMap = 1,
  HereMap = 2,
  MapBox = 3,
}
